var CustomSelect = (function () {
  var OPEN_CLASS = "cs-open";
  var WRAPPER_CLASS = "cs-wrapper";
  var DISPLAY_CLASS = "cs-display";
  var DROPDOWN_CLASS = "cs-dropdown";
  var OPTION_CLASS = "cs-option";
  var OPTION_SELECTED_CLASS = "cs-option--selected";

  function wrap(select) {
    if (select.dataset.csInit) return;
    select.dataset.csInit = "1";
    select.style.position = "absolute";
    select.style.opacity = "0";
    select.style.pointerEvents = "none";
    select.style.width = "0";
    select.style.height = "0";
    select.style.overflow = "hidden";
    select.setAttribute("tabindex", "-1");

    var wrapper = document.createElement("div");
    wrapper.className = WRAPPER_CLASS;

    var display = document.createElement("span");
    display.className = DISPLAY_CLASS;
    display.textContent = selectedText(select);

    var arrow = document.createElement("span");
    arrow.className = "cs-arrow";
    arrow.innerHTML = "&#9662;";

    var dropdown = document.createElement("ul");
    dropdown.className = DROPDOWN_CLASS;

    buildOptions(dropdown, select);

    wrapper.appendChild(display);
    wrapper.appendChild(arrow);
    wrapper.appendChild(dropdown);
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);

    wrapper.addEventListener("click", function (e) {
      e.stopPropagation();

      if (e.target.classList.contains(OPTION_CLASS)) {
        pickOption(wrapper, select, e.target.dataset.value);
        close(wrapper);
        return;
      }

      if (wrapper.classList.contains(OPEN_CLASS)) {
        close(wrapper);
      } else {
        closeAll();
        open(wrapper);
      }
    });

    wrapper.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close(wrapper);
    });
  }

  function buildOptions(dropdown, select) {
    dropdown.innerHTML = "";
    Array.prototype.forEach.call(select.options, function (opt) {
      var li = document.createElement("li");
      li.className = OPTION_CLASS;
      li.dataset.value = opt.value;
      li.textContent = opt.textContent;
      if (opt.selected) li.classList.add(OPTION_SELECTED_CLASS);
      dropdown.appendChild(li);
    });
  }

  function selectedText(select) {
    var opt = select.options[select.selectedIndex];
    return opt ? opt.textContent : "";
  }

  function pickOption(wrapper, select, value) {
    select.value = value;
    wrapper.querySelector("." + DISPLAY_CLASS).textContent = selectedText(select);
    var items = wrapper.querySelectorAll("." + OPTION_CLASS);
    items.forEach(function (li) {
      li.classList.toggle(OPTION_SELECTED_CLASS, li.dataset.value === value);
    });
    select.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function open(wrapper) {
    wrapper.classList.add(OPEN_CLASS);
  }

  function close(wrapper) {
    wrapper.classList.remove(OPEN_CLASS);
  }

  function closeAll() {
    document.querySelectorAll("." + WRAPPER_CLASS + "." + OPEN_CLASS).forEach(function (w) {
      w.classList.remove(OPEN_CLASS);
    });
  }

  function refresh(wrapper) {
    var select = wrapper.querySelector("select");
    if (!select) return;
    var dropdown = wrapper.querySelector("." + DROPDOWN_CLASS);
    buildOptions(dropdown, select);
    wrapper.querySelector("." + DISPLAY_CLASS).textContent = selectedText(select);
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll("select").forEach(function (sel) {
      wrap(sel);
    });
  }

  document.addEventListener("click", function () {
    closeAll();
  });

  return { init: init, refresh: refresh, wrap: wrap };
})();

window.CustomSelect = CustomSelect;
